import {observer} from "mobx-react-lite";
import {TeamStore} from "./team-store";
import useDataListFetch from "../../../utils/form/useDataListFetch";
import StandalonePopover from "../../../components/ui/StandalonePopover";
import {Field, Form} from "react-final-form";
import {TeamUpdateInput} from "../../../generated";
import {Input, MultiSelect, Select} from "../../../components/ui";
import {FinalButtonSet} from "../../../components/ui/form";
import React from "react";

export const TeamEditModal = observer((props: { store: TeamStore }) => {
    const {store} = props;
    const managersDataList = useDataListFetch('engineers+admins');
    const membersDataList = useDataListFetch('engineers+admins');

    return <StandalonePopover
        title={store.model ? 'Update team' : 'Create team'}
        columnCount={2}
        closePopover={() => store.closeTeamModal()}
    >
        <Form<TeamUpdateInput>
            onSubmit={(values) => {
                return store.submit(values)
            }}
            initialValues={
                store.model ? {
                    name: store.model.name,
                    manager: `/api/users/${store.model.manager.id}`,
                    members: store.model.members.map(member => `/api/users/${member.id}`),
                } : {}
            }
            render={({handleSubmit, pristine, submitting}) =>
                <form onSubmit={handleSubmit}>
                    <Field
                        name='name'
                        label='Name'
                        component={Input}
                    />

                    <Field
                        type='text'
                        name='manager'
                        label={'Manager'}
                        component={Select}
                        {...managersDataList}
                    />

                    <Field name={'members'}
                           label={'Members'}
                           component={MultiSelect}
                           {...membersDataList}
                    />

                    <FinalButtonSet submitting={submitting} pristine={pristine} mode={"RELATIVE"}/>
                </form>}/>
    </StandalonePopover>
})